<template>
  <div class="">
    <div
      class="cursor-pointer"
      @click="setDatePickerDisplay(true)"
    >
      <div class="flex items-center">
        <DateViewer :date="dateModel" />

        <div>
          <i class="far fa-chevron-down" />
        </div>
      </div>
    </div>

    <DatePicker
      v-if="datePickerState.display"
      :date="dateModel"
      class="relative z-20"
      @dateChanged="dateChanged"
    />

    <div
      v-if="datePickerState.display"
      class="z-10 fixed top-0 left-0 w-full min-w-full h-full min-h-full"
      @click="setDatePickerDisplay(false)"
    />
  </div>
</template>

<script>
import DatePicker from '@/app/shared/components/date/datePicker.vue';
import DateViewer from '@/app/shared/components/date/dateViewer.vue';

export default {

  components: {
    DatePicker,
    DateViewer,
  },

  props: {
    date: {
      type: Date,
      default: undefined,
    },
  },

  data() {
    return {
      dateModel: undefined,
      datePickerState: {
        display: false,
      },
    };
  },

  computed: {

  },

  watch: {

  },

  mounted() {
    this.dateModel = this.date;
  },

  created() {

  },

  methods: {
    dateChanged(changedDate) {
      this.setDatePickerDisplay(false);
      this.dateModel = changedDate;
      if (this.dateModel !== undefined) {
        this.$emit('dateChanged', this.dateModel);
      }
    },

    setDatePickerDisplay(value) {
      this.datePickerState.display = value;
    },
  },


};
</script>
